import React from "react";
import "./Auth.css";
import AuthSideContent from "./AuthSideContent";

function AuthLayout({ children, backgroundImage }) {
  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Left Side - Image/Logo */}
        <div className="auth-left">
          <AuthSideContent backgroundImage={backgroundImage} />
        </div>

        {/* Right Side - Form */}
        <div className="auth-right">
          <div className="auth-form-container">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
